export interface ListItemDTO {
    id: number;
    listId: number;
    checked: boolean;
    description: string;
    deadline: Date;
    taskId: number;
    changeDate: Date;
    position: number;
}

export interface ListItemWriteDTO {
    listId: number;
    checked: boolean;
    description: string;
    deadline: Date;
    taskId: number;
    changeDate: Date;
    position: number;
}

export function createListItem(    listId: number,
    checked: boolean,
    description: string,
    deadline: Date,
    taskId: number,
    changeDate: Date,
    position: number
) {
    return {
        listId: listId, checked: checked, description: description, deadline: deadline, taskId: taskId, changeDate: changeDate, position: position}
}